/**
 * Display label for a property: "Name (CODE)".
 *
 * The CRS property code disambiguates hotels that exist as multiple
 * instances (e.g. an offline version and a CRS version share the same
 * propertyName but have distinct codes, like "Rove City Walk (TC00171)"
 * vs "Rove City Walk (HTROC)"). Falls back to the bare name when the
 * code is missing.
 */
export const formatPropertyLabel = (property) => {
  const name = property?.propertyName;
  if (!name) return "";
  const code = property?.propertyCode;
  return code ? `${name} (${code})` : name;
};
